"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* ++++++++++ --------------- EXPORT : SUBHEAD : STYLES --------------- ++++++++++ */


var _default = _defineProperty({
  subhead: {
    background: _index.theme.color.supporting.dark.swatch,
    color: _index.theme.color.supporting.dark.contrast,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    // height: pxToEm(94),
    width: '100%',
    padding: (0, _index.replacePXinStringWithEM)("32px ".concat(_index.theme.spacing.sides)),
    transition: _index.theme.animation.general('all'),
    '& h1': {
      fontSize: (0, _index.pxToEm)(26),
      fontWeight: 'normal'
    },
    // animation
    opacity: '0',
    animationName: 'fadeInRight',
    animationDelay: '.1s',
    animationDuration: '.2s',
    animationFillMode: 'forwards',
    // used on embeds and reports to show unique embed name or report name
    '& .uniquename': {
      color: _index.theme.color.primary.medium.swatch,
      fontSize: '65%',
      paddingRight: (0, _index.pxToEm)(10),
      opacity: '0',
      animationName: 'fadeInLeft',
      animationDelay: '1.1s',
      // this will be custom per section depending on the animation timing of that sections contents (for example, embeds will have a much longer delay than reports)
      animationDuration: '.2s',
      animationFillMode: 'forwards'
    },
    '& .ctas': {
      '& .link': {
        color: _index.theme.color.supporting.light.swatch,
        opacity: '0',
        animationName: 'fadeInRight',
        animationDelay: '1.1s',
        // will be section dependant just like uniquename
        animationDuration: '.2s',
        animationFillMode: 'forwards'
      }
    }
  }
}, _index.mediaQuery.thinnest, {
  subhead: {
    // height: pxToEm(70),
    paddingTop: (0, _index.pxToEm)(23),
    paddingBottom: (0, _index.pxToEm)(23),
    '& h1': {
      fontSize: (0, _index.pxToEm)(20)
    },
    '& .ctas': {
      '& .button, .link': {
        fontSize: (0, _index.pxToEm)(13)
      }
    }
  }
});

exports.default = _default;